import { Service, inject } from '@angular/core';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { chain } from 'lodash';
import { forkJoin } from 'rxjs';
import { ONYX_ICONS } from '../../components/icons/constants';

@Service()
export class OnyxIconRegistryService {
  private readonly iconRegistry = inject(SvgIconRegistryService);

  constructor() {
    chain(ONYX_ICONS)
      .flatMap((group) => group)
      .map((icon) => this.iconRegistry.loadSvg(`icons/${icon}.svg`, icon)!)
      .thru((promises) => forkJoin(promises).subscribe())
      .value();
  }
}
